// export class Ejecutivo {
//     constructor(ejecutivo, Armenia, Barrancabermeja, Barranquilla, BogotaNorte, BogotaSur, Bucaramanga, Cali, Cartagena, Cucuta, Girardot, Ibague, Manizales, Medellin, Monteria, NoAplica, Neiva, Pasto, Pereira, Popayan, SantaMarta, Sincelejo, Tunja, Valledupar, Villavicencio, Yopal) {
//         this.ejecutivo = ejecutivo;
//         this.Armenia = Armenia;
//         this.Barrancabermeja =Barrancabermeja;
//         this.Barranquilla=Barranquilla;
//         this.BogotaNorte=BogotaNorte;
//         this.BogotaSur=BogotaSur;
//         this.Bucaramanga=Bucaramanga;
//         this.Cali=Cali;
//         this.Cartagena=Cartagena;
//         this.Cucuta=Cucuta;
//         this.Girardot=Girardot;
//         this.Ibague=Ibague;
//         this.Manizales=Manizales;
//         this.Medellin=Medellin;
//         this.Monteria=Monteria;
//         this.NoAplica=NoAplica;
//         this.Neiva=Neiva;
//         this.Pasto=Pasto;
//         this.Pereira=Pereira;
//         this.Popayan=Popayan;
//         this.SantaMarta=SantaMarta;
//         this.Sincelejo=Sincelejo;
//         this.Tunja=Tunja;
//         this.Valledupar=Valledupar;
//         this.Villavicencio=Villavicencio;
//         this.Yopal=Yopal;
//     }
// }

export class Cumplimiento {
    constructor(Ejecutivo, Ejecucion, Meta) {
        this.Ejecutivo = Ejecutivo;
        this.Ejecucion = Ejecucion;
        this.Meta=Meta;
    }
}